import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { Subscription } from 'rxjs';
import { UploadsService } from '../../service/uploads.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { UploadsModel } from 'src/app/models/upload/uploads.model';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/service/global.service';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { extractApiErrorMessage } from '../upload-template.util';

@Component({
  selector: 'app-template-view',
  templateUrl: './template-view.component.html',
  styleUrls: ['./template-view.component.css']
})
export class TemplateViewComponent implements OnInit, OnDestroy {

  public uploadsModel = new UploadsModel();
  public refreshing = false;
  public loggedinUser = '';
  actionButtons: { name: string; class: string }[];

  myDocsData: UploadsModel[] = [];
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns1: TableColumn[];
  actions: { name: string; dataKey: string; position: string; isSortable: boolean; class: string }[];
  myTemplateSet = new Set<string>();
  isAccessDisabled = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private httpService: HttpClient,
    private uploadsService: UploadsService,
    public ete: ExportExcelService,
    private authGaurdService: AuthGaurdService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.isAccessDisabled = this.globalService._permissionCheck('template-view');
    this.loggedinUser = this.authGaurdService.loginUser();
    this.initializeColumns();
    this.initializeExcelHeaders();
    this.getTemplatesList();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  public getTemplatesList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.uploadsService.getTemplatesList().subscribe(
        (response: UploadsModel[]) => {
          this.myDocsData = response.sort((a, b) => a.recordname.localeCompare(b.recordname));
          this.refreshing = false;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
          this.refreshing = false;
        }
      )
    );
  }

  initializeExcelHeaders(): void {
    this.subscriptions.push(
      this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(data => {
        this.ordersTableExcelHeaderColumns = data['UploadsTemplate'];
      })
    );
  }

  exportExcel(): void {
    const rows = this.myDocsData.map(row => ({
      'Record Name': row.recordname,
      'Record Template': row.recordtemplate,
      'Description': row.recorddesc
    }));
    this.ete.exportFromJsonRows(rows, 'UploadsTemplate');
  }

  updateTemplate(recordname: string, recorddesc: string, recordtemplate: string): void {
    this.uploadsModel.recordname = recordname;
    this.uploadsModel.recorddesc = recorddesc;
    this.uploadsModel.recordtemplate = recordtemplate;
    this.uploadsService.uploadsModel = this.uploadsModel;
    this.uploadsService.myTemplateSet = this.myTemplateSet;
    this.router.navigate(['/template-edit'], {
      queryParams: { recordname }
    });
  }

  public deleteTemplate(id: number, recordname: string, recordtemplate: string): void {
    if (confirm('Are you sure to delete this template')) {
      this.subscriptions.push(
        this.uploadsService.deleteTemplate(id, recordname, recordtemplate).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
            this.getTemplatesList();
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
          }
        )
      );
    }
  }

  downloadExcelHeaders(recordname: string): void {
    this.subscriptions.push(
      this.uploadsService.getRecordsList(recordname).subscribe(
        (response: UploadsModel[]) => {
          this.ete.exportHeaderOnlyTemplate('Template', response);
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  rowAction(row: { row: UploadsModel; value: string }): void {
    if (row.value === 'Download') {
      this.downloadExcelHeaders(row.row.recordname);
    } else if (row.value === 'Update') {
      this.updateTemplate(row.row.recordname, row.row.recorddesc, row.row.recordtemplate);
    } else if (row.value === 'Delete') {
      this.deleteTemplate(row.row.templateid, row.row.recordname, row.row.recordtemplate);
    }
  }

  actionOnButton(action: string): void {
    if (action === 'Add') {
      if (this.isAccessDisabled) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.redirect('template-create');
      }
    }
  }

  redirect(url: string): void {
    this.router.navigate(['/' + url]);
  }

  initializeColumns(): void {
    this.subscriptions.push(
      this.httpService.get('../../../assets/json/tableColumns.json').subscribe(data => {
        this.ordersTableColumns1 = data['UploadsTemplate'];
      })
    );
    this.actions = [
      { name: 'Update', dataKey: 'fas fa-edit success f-25', position: 'left', isSortable: false, class: 'badge bg-danger' },
      { name: 'Delete', dataKey: 'fas fa-trash-alt danger f-25', position: 'left', isSortable: false, class: 'badge bg-danger' },
      { name: 'Download', dataKey: 'fas fa-download success f-25', position: 'left', isSortable: false, class: 'badge bg-danger' }
    ];
    this.actionButtons = [{ name: 'Add', class: 'btn btn-success btn-xs' }];
  }
}
